import React from 'react'
import { ReactComponent as IconSatis } from '../../../../../../assets/icons/u_alert-check.svg'
import { OnePagerDoughnutChart } from '../../../components/OnePagerDoughnutChart'

const PmrIgr = ({ pmr }) => {
    return (
        <div className="pmr">
            <div className='pmrIconContent'>
                <p>PMR</p>
                <IconSatis />
            </div>
            <OnePagerDoughnutChart data={pmr} />
        </div>
    )
}

export default PmrIgr